import script from "./DownloadDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDialog.vue?vue&type=style&index=0&id=0eff0044&scoped=true&lang=css"

import exportComponent from "/var/www/html/laraccm2021/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eff0044"]])

export default __exports__